import React from 'react';

import {assert} from 'Asserts';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {
  type AnalyzeProcedureRunActionParams,
  useAnalyzeProcedureRunAction,
} from './useAnalyzeProcedureRunAction';

/**
 * Props for AnalyzeProcedureRunButton component.
 *
 * @package exported for testing.
 */
export type AnalyzeProcedureRunButtonProps = AnalyzeProcedureRunActionParams;

/**
 * Legacy full-text "Analyze" button used by the legacy StudyExecutionHeader (flag-off / out-of-scope
 * studies). The new Mantine header consumes {@link useAnalyzeProcedureRunAction} directly as an icon
 * action; both share the same disabled/tooltip/modal logic.
 */
export default function AnalyzeProcedureRunButton(props: AnalyzeProcedureRunButtonProps): JSX.Element {
  assert(props.procedureRunId != null, 'Procedure Run is not selected');

  const action = useAnalyzeProcedureRunAction(props);
  const isDisabled = action.isDisabled ?? false;

  return (
    <Tooltip text={action.disabledTooltip ?? null} isDisabled={!isDisabled || action.disabledTooltip == null}>
      <Button
        dataTestAttrs={action.dataTestAttrs}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.MEDIUM}
        onClick={action.onSelect}
        text={action.name}
        icon={action.icon}
        disabled={isDisabled}
      />
    </Tooltip>
  );
}
